import { UrlHelper } from '@bridebook/web/lib/url-helper';

// TODO: [i18n][bb-global] rename locale to urlParam?
const getFacetFilterUrl = (locale: string, searchParams: Array<string>, filterKey: string) =>
  `/${locale}${UrlHelper.search}/${searchParams[0]}/${searchParams[1]}/${filterKey}`;

export default getFacetFilterUrl;
